import { render, staticRenderFns } from "./formUser.vue?vue&type=template&id=16847f5a&"
import script from "./formUser.vue?vue&type=script&lang=js&"
export * from "./formUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports